import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Button, Modal, message } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { gethistory, deleteHistory } from "store/auth/profile/profileSlice";
import { HistoryForm } from "./historyForm";

const Historique = () => {
  const dispatch = useDispatch();
  const history = useSelector((state) => state.Profile.history);
  const profile = useSelector((state) => state.Profile.profile);

  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    dispatch(gethistory(profile?._id));
  }, [dispatch, profile]);

  const handleAdd = () => {
    setIsEditMode(false);
    setEditData(null);
    setShowModal(true);
  };

  const handleEdit = (item) => {
    setIsEditMode(true);
    setEditData(item);
    setShowModal(true);
  };
  const handlDelete = async (id) => {
    try {
      const response = await dispatch(deleteHistory(id))
      message.success('deleted succesfully')
      dispatch(gethistory(profile?._id))

    } catch (error) {
      message.error(error)
    }
  }



  return (
    <div className="py-4">
      <div className="
            container
            bg-light
            rounded-3
            shadow-sm
            p-3 p-sm-4 p-md-5
            mx-auto
          "
      >

        {/* Add button */}
        <div className="mb-4 d-flex justify-content-end">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleAdd}
          >
            Ajouter une expérience
          </Button>
        </div>

        <div
          style={{
            backgroundColor: "#F4F4F4",
            fontSize: "20px",
            fontWeight: "400",
            padding: "40px",
            borderRadius: "10px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          {history && history?.history?.length > 0 ? (
            history?.history?.map((item, key) => (
              <Card key={key} style={{ marginBottom: "30px" }}>
                <Row gutter={[16, 16]}>
                  <Col span={20} className="d-flex align-items-center gap-3">
                    <h3 className="fs-5 fs-sm-4 fs-md-3">{item.clubName}</h3>
                    <h6 className="fs-6 fs-sm-5 fs-md-4 mb-0">
                      {item.dateRange.startDate.slice(0, 4)}-
                      {item.dateRange.endDate.slice(0, 4)}
                    </h6>
                    <h5 className="fs-6 fs-sm-5 fs-md-4 mb-0">{item.category}</h5>
                  </Col>
                  <Col span={4} className="d-flex justify-content-end">
                    <Button
                      icon={<EditOutlined />}
                      onClick={() => handleEdit(item)}
                      style={{ marginRight: "8px" }}
                    />
                    <Button
                      icon={<DeleteOutlined />}
                      onClick={() => handlDelete(item._id)}
                      style={{ marginRight: "8px" }}
                    />

                  </Col>

                  <Col
                    style={{ backgroundColor: "#F3F8F9" }}
                    className="fs-6 fs-sm-5 fs-md-4"
                    span={6}
                  >
                    Post
                  </Col>
                  <Col
                    style={{ backgroundColor: "#F3F8F9" }}
                    className="fs-6 fs-sm-5 fs-md-4"
                    span={6}
                  >
                    Match jouées
                  </Col>
                  <Col
                    style={{ backgroundColor: "#F3F8F9" }}
                    className="fs-6 fs-sm-5 fs-md-4"
                    span={6}
                  >
                    but Marqués
                  </Col>
                  <Col
                    style={{ backgroundColor: "#F3F8F9" }}
                    className="fs-6 fs-sm-5 fs-md-4"
                    span={6}
                  >
                    Passes décisives
                  </Col>
                  <Col span={6} className="fs-6 fs-sm-5 fs-md-4">{item.position}</Col>
                  <Col span={6} className="fs-6 fs-sm-5 fs-md-4">{item.matchesPlayed}</Col>
                  <Col span={6} className="fs-6 fs-sm-5 fs-md-4">{item.goalsScored}</Col>
                  <Col span={6} className="fs-6 fs-sm-5 fs-md-4">{item.assists}</Col>
                </Row>
              </Card>
            ))
          ) : (
            <div className="text-center py-5">
              <p>Aucune expérience trouvée. Ajoutez votre première expérience.</p>
            </div>
          )}
        </div>

        {/* Modal for adding/editing history */}
        <Modal
          title={isEditMode ? "Modifier l'expérience" : "Ajouter une expérience"}
          open={showModal}
          onCancel={() => setShowModal(false)}
          footer={null}
          width={800}
        >
          <HistoryForm
            setShowModal={setShowModal}
            editMode={isEditMode}
            initialData={editData}
          />
        </Modal>
      </div>
    </div>
  );
};

export default Historique;